<div [ngClass]="[color, customClass, compressed ? 'compressed' : '']"
  class="alert alert-primary d-flex align-items-center" role="alert">
  <i *ngIf="color==='success'" class="fa-solid fa-circle-check ms-2" style="width: 11px;"></i>
  <i *ngIf="color==='warning'" class="fa-solid fa-triangle-exclamation ms-2" style="width: 11px;"></i>
  <i *ngIf="color==='info'" class="fa-solid fa-circle-exclamation ms-2" style="width: 11px;"></i>
  <div class="mx-2 texto">
    <ng-content></ng-content> <!-- Texto o contenido del botón -->
  </div>
</div>